"use strict";

var _interopRequireWildcard = require("reshow-runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _createClass2 = _interopRequireDefault(require("reshow-runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("reshow-runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("reshow-runtime/helpers/defineProperty"));
var _getoffset = _interopRequireWildcard(require("getoffset"));
var _getScrollInfo = _interopRequireWildcard(require("get-scroll-info"));
var _getDomPositionInfo = _interopRequireDefault(require("./getDomPositionInfo.js"));
var _getAfterMove = _interopRequireDefault(require("./getAfterMove.js"));
var _getWindowOffset = _interopRequireDefault(require("./getWindowOffset.js"));
var _alignWith = _interopRequireDefault(require("./alignWith.js"));
var _isFullOnScreen = _interopRequireDefault(require("./isFullOnScreen.js"));
var _getPositionString = _interopRequireDefault(require("./getPositionString.js"));
var _type = require("./type.js");
// @ts-check

var fixFixedNode = function fixFixedNode( /** @type ScrollInfoType*/scrollInfo) {
  return function ( /**@type number[]*/move) {
    return [move[0] + scrollInfo.left, move[1] + scrollInfo.top];
  };
};
var fixScrollNode = function fixScrollNode( /** @type ScrollInfoType*/scrollInfo) {
  return function ( /**@type number[]*/move) {
    return [move[0] - scrollInfo.left, move[1] - scrollInfo.top];
  };
};
var AlignParamsType = /*#__PURE__*/(0, _createClass2["default"])(function AlignParamsType() {
  (0, _classCallCheck2["default"])(this, AlignParamsType);
  /**
   * @type string
   */
  (0, _defineProperty2["default"])(this, "toLoc", void 0);
  /**
   * @type boolean
   */
  (0, _defineProperty2["default"])(this, "disableAutoLoc", void 0);
  /**
   * @type boolean
   */
  (0, _defineProperty2["default"])(this, "positionFixed", void 0);
  /**
   * @type string[]
   */
  (0, _defineProperty2["default"])(this, "exclude", void 0);
});
var AlignUIResultType = /*#__PURE__*/(0, _createClass2["default"])(function AlignUIResultType() {
  (0, _classCallCheck2["default"])(this, AlignUIResultType);
  /**
   * @type string|undefined
   */
  (0, _defineProperty2["default"])(this, "loc", void 0);
  /**
   * @type [number, number]
   */
  (0, _defineProperty2["default"])(this, "move", void 0);
  /**
   * @type string|undefined
   */
  (0, _defineProperty2["default"])(this, "toLoc", void 0);
  /**
   * @type string|undefined
   */
  (0, _defineProperty2["default"])(this, "locClassName", void 0);
});
/**
 * @param {HTMLElement} targetEl
 * @param {HTMLElement} floatEl
 * @param {AlignParamsType} alignParams
 * @param {WindowOffsetType} winInfo
 * @returns {AlignUIResultType|false}
 */
var alignUI = function alignUI(targetEl, floatEl, alignParams, winInfo) {
  var _ref = alignParams || {},
    toLoc = _ref.toLoc,
    disableAutoLoc = _ref.disableAutoLoc,
    positionFixed = _ref.positionFixed,
    exclude = _ref.exclude;
  if (!targetEl) {
    console.warn("targetEl was empty", {
      targetEl: targetEl
    });
    return false;
  }
  var locs = [];
  if (toLoc) {
    locs.push(toLoc);
  }
  if (!disableAutoLoc) {
    winInfo = winInfo || (0, _getWindowOffset["default"])(targetEl);
    if (!winInfo) {
      console.warn("get windows offset failed", {
        targetEl: targetEl
      });
    } else {
      locs = locs.concat(winInfo.locs);
    }
  }
  if (!locs.length) {
    console.warn("Not set any locs", {
      toLoc: toLoc
    });
    return false;
  }
  var targetInfo = winInfo ? winInfo.domInfo : (0, _getDomPositionInfo["default"])(targetEl).domInfo;
  if (!targetInfo) {
    console.warn("[alertUI] can't get target info.", {
      targetEl: targetEl,
      winInfo: winInfo
    });
    return false;
  }
  var adjustMove;
  /**
   * @type HTMLElement
   */
  var overflowNode = /**@type HTMLElement*/targetInfo.overflowNode;
  /**
   * @type HTMLElement
   */
  var fixedNode = /**@type HTMLElement*/targetInfo.fixedNode;
  if (fixedNode) {
    if (fixedNode.contains(floatEl)) {
      adjustMove = fixFixedNode((0, _getScrollInfo["default"])(fixedNode));
    } else if (positionFixed) {
      adjustMove = fixScrollNode((0, _getScrollInfo["default"])(fixedNode));
    } else {
      if (winInfo) {
        adjustMove = fixFixedNode(winInfo.scrollInfo);
      } else {
        adjustMove = fixFixedNode((0, _getScrollInfo["default"])());
      }
    }
  } else if (overflowNode) {
    adjustMove = fixScrollNode((0, _getScrollInfo["default"])(overflowNode));
  }
  var loc;
  var move;
  /**
   * @type OffsetType
   */
  var floatInfo = /** @type OffsetType*/(0, _getoffset["default"])(floatEl);
  locs.some(function (locItem) {
    /**
     * @type string
     */
    loc = locItem;
    if (exclude && -1 !== exclude.indexOf(loc)) {
      return false;
    }
    move = (0, _alignWith["default"])(targetInfo, floatInfo, loc);
    if (adjustMove) {
      move = adjustMove(move);
    }
    if (!winInfo) {
      return true;
    } else {
      var movePos = (0, _getAfterMove["default"])(floatInfo, move);
      var bFullOnScreen = (0, _isFullOnScreen["default"])(movePos, winInfo.scrollInfo);
      if (bFullOnScreen) {
        return true;
      } else {
        return false;
      }
    }
  });
  if (!move) {
    return false;
  }
  var result = {
    loc: loc,
    move: move,
    toLoc: toLoc || loc,
    locClassName: (0, _getPositionString["default"])(loc)
  };
  //   console.log(result, {locs, winInfo});
  return result;
};
var _default = exports["default"] = alignUI;
module.exports = exports.default;